import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLocation } from '../../contexts/LocationContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiMapPin } = FiIcons;

const AdminHeader = () => {
  const { currentUser } = useAuth();
  const { selectedLocation, locations, selectLocation } = useLocation();

  return (
    <header className="bg-white border-b border-warm-brown/10 px-6 py-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-playfair text-warm-brown">Dashboard</h1>
          <p className="text-warm-brown/70">Manage your La Vie Saigon operations</p>
        </div>
        
        <div className="flex items-center gap-4">
          {/* Location Selector */}
          {locations.length > 1 && (
            <div className="flex items-center gap-2">
              <SafeIcon icon={FiMapPin} className="text-warm-brown" />
              <select
                value={selectedLocation?.id || ''}
                onChange={(e) => {
                  const location = locations.find(loc => loc.id === parseInt(e.target.value));
                  selectLocation(location);
                }}
                className="px-3 py-2 border border-warm-brown/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-warm-brown/50 text-warm-brown"
              >
                {locations.map(location => (
                  <option key={location.id} value={location.id}>
                    {location.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* User Info */}
          <div className="flex items-center gap-3">
            <div className="bg-cream p-2 rounded-full">
              <SafeIcon icon={FiUser} className="text-warm-brown text-lg" />
            </div>
            <div>
              <p className="text-warm-brown font-medium">{currentUser?.username}</p>
              <p className="text-warm-brown/70 text-sm">{currentUser?.role}</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;